import getConfig from 'next/config';
import { CustomBetterStackEvent } from './types';
import { createPayload } from './utils';

const { publicRuntimeConfig } = getConfig() || {};

const sendLog = (event: CustomBetterStackEvent, baseUrl: string) =>
    fetch(baseUrl + '/api/integrations/logs', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(createPayload(event, baseUrl)),
    });

// A failed log must never break the flow that logs it.
export const clientLog = async (event: CustomBetterStackEvent) => {
    try {
        await sendLog(event, publicRuntimeConfig.NEXT_PUBLIC_URL);
    } catch (error) {
        console.error(`Better Stack log "${event.event}" failed.`, error);
    }
};
